import { request } from '@/utils/request';

const urls = {
  list: '/zlb/api/pay/bankCard/personal', // 列表
  bankList: '/zlb/api/pay/bankCard/bank/list', // 银行列表
  cityList: '/zlb/api/pay/bankCard/city', // 城市列表
  branchBankList: '/zlb/api/pay/bankCard/bank/branch/list', // 支行列表
  addBankCard: '/zlb/api/pay/bankCard/add', // 新增银行卡
  setDefault: '/zlb/api/pay/bankCard/setDefault', // 设为默认
  // deleteCard: '/zlb/api/pay/bankCard/delete', // 解绑公务卡、删除银行卡
  deleteCard: '/zlb/api/pay/bankCard/delete-by-userId', // 解绑公务卡、删除银行卡
  ocr: '/niepan/api/ocr/api-ocr', // ocr
  address: '/api/user/address/specifiedLevelTree?level=2', // 城市列表
  detail: '/zlb/api/pay/bankCard/detail', // 银行卡详情
  edit: '/zlb/api/pay/bankCard/edit', // 编辑银行卡
  queryBankInfo: '/zlb/api/pay/bankCard/bank/info', // 根据银行卡号查询银行
  personalBankList: '/zlb/api/pay/bankCard/bank/personal/list' // 银行卡号查找银行（个人，银行列表接口替换）
};

export async function reqList (data) {
  return request(urls.list, {
    data,
    method: 'POST',
  });
}

export async function reqBankList (params) {
  return request(urls.bankList, {
    params,
  });
}

export async function reqPersonalBankList (params) {
  return request(urls.personalBankList, {
    params,
  });
}
export async function reqCityList (params) {
  return request(`${urls.cityList}/${params}`);
}

export async function reqBranchBankList (data) {
  return request(urls.branchBankList, {
    method: 'POST',
    data,
  });
}

export async function reqAddBankCard (data) {
  return request(urls.addBankCard, {
    method: 'POST',
    data,
  });
}

export async function reqSetDefault (data) {
  return request(`${urls.setDefault}/${data.accountCode}`, {
    method: 'POST',
  });
}

export async function reqDeleteCard (data) {
  return request(`${urls.deleteCard}/${data.accountCode}`, {
    method: 'POST',
  });
}

export async function reqOcr (data) {
  return request(urls.ocr, {
    method: 'POST',
    data,
  });
}

export async function reqAddress (params) {
  return request(urls.address, {
    params,
  });
}

export async function reqDetail (params) {
  return request(`${urls.detail}/${params.accountCode}`);
}

export async function reqEdit (data) {
  return request(urls.edit, {
    method: 'POST',
    data,
  });
}
/**
 * 获取可绑定的公务卡
 * @param {*} params 
 * @returns 
 */
export async function getBindableOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/bindable', {
    params,
  });
}
/**
 * 获取已绑定公务卡
 * @param {*} params 
 * @returns 
 */
export async function getBoundOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/bound', {
    params,
  });
}

/**
 * 获取异常的公务卡
 * @param {*} params 
 * @returns 
 */
export async function getUnavailableOfficialCard (params) {
  return request('/zlb/api/pay/bankCard/official/illegal', {
    params,
  });
}
/**
 * 批量绑定银行卡
 * @param {*} data 
 * @returns 
 */
export async function bindOfficialCard (data) {
  return request('/zlb/api/pay/bankCard/official/bind', {
    data,
    method: 'POST',
  });
}
/**
 * 批量解绑银行卡
 * @param {*} data 
 * @returns 
 */
export async function unbindOfficialCard (data) {
  return request('/zlb/api/pay/bankCard/official/unbind', {
    data,
    method: 'POST',
  });
}

/**
 * 根据银行卡号查询银行
 * @param {*} data 
 * @returns 
 */
export async function queryBankInfo (data) {
  return request(urls.queryBankInfo, {
    method: 'POST',
    data,
  });
}

